require.register("javascripts/html5-game/Boot", function(exports, require, module){
  /*hook for custom classes & methods */
window.TGA = {};

var HTML5Game = HTML5Game || {};
var utils = require('lib/utils');

HTML5Game.Boot = function (game) {

};

HTML5Game.Boot.prototype = {
  preload: function () {
    if (utils.coursePath('').length > 0) {
      this.game.load.crossOrigin = 'anonymous';
    }

    this.initFilePath();
    this.centerCanvas();
  },
  create: function () {
    //  So now let's start the real preloader going
    this.state.start('Preloader');
  },
  initFilePath:function () {
    TGA.IMG_FP = utils.coursePath('images/html5-game/');
  },
  centerCanvas:function(){
    this.game.HTML5GameService.centerCanvas();
  }
};

module.exports = HTML5Game;


  
});

